import Phonses from "../Detials/phones"
import Otherthree from "../Detials/otherthree"



function Rowone(){
    return(
        <>
        <Phonses/>
        <Otherthree/>

        </>
    )
}
export default Rowone